import { useState, useCallback, useEffect } from 'react';
import { courseToKey } from '@pm2/course-builder';
import { createSearchFriendlyString } from '@utils/common';
import { useSelf } from '@utils/react';

let CourseSections = /*#__PURE__*/function (CourseSections) {
  CourseSections[CourseSections["MY_COURSES"] = 0] = "MY_COURSES";
  CourseSections[CourseSections["SHARED"] = 1] = "SHARED";
  return CourseSections;
}({});
/**
 * Filters courses based on filters supplied by the teacher heading
 */
function useFilteredCourses(courses) {
  const options = useSelf({
    section: CourseSections.MY_COURSES
  });
  const [filteredCourses, setFilteredCourses] = useState(() => filterCourses(courses, options));
  const applyFiltering = useCallback(() => {
    setFilteredCourses(filterCourses(courses, options));
  }, [courses, options]);
  const onSectionChange = useCallback(newSection => {
    options.section = newSection;
    applyFiltering();
  }, [applyFiltering, options]);
  const onQueryChange = useCallback(newQuery => {
    options.query = newQuery;
    applyFiltering();
  }, [applyFiltering, options]);

  // Ensure that a new fukter is applied every time the list of courses
  // is changed externally.
  useEffect(() => {
    setFilteredCourses(filterCourses(courses, options));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
  // eslint-disable-next-line react-hooks/exhaustive-deps
  courses.map(it => `${courseToKey(it)}-${!!it.shareNotification}`).join("-"), options]);
  return [filteredCourses, options, {
    onSectionChange,
    onQueryChange
  }];
}

/**
 * Courses will be filtered firstly based on the section that should be
 * currently visible, and afterwards the currently applied search query
 */
function filterCourses(courses, options) {
  const sectionedCourses = courses.filter(course => options.section === CourseSections.MY_COURSES ? !course.shared : !!course.shared);
  if (!options.query) {
    return sectionedCourses;
  }
  const needle = createSearchFriendlyString(options.query);
  return sectionedCourses.filter(course => {
    const haystack = createSearchFriendlyString(`${course.title} ${course.subjects.join(" ")} ${course.levels.join(" ")}`);
    return haystack.includes(needle);
  });
}

export { CourseSections, filterCourses, useFilteredCourses };
//# sourceMappingURL=filtered-courses.js.map
